import * as React from 'react';
import { AgGridReact } from "ag-grid-react";
import { ColDef, IHeaderParams, ICellRendererParams, FirstDataRenderedEvent } from "ag-grid-community";
import { GridWrapper } from './grid-wrapper'
import { IVoucherSimulationConfigOutput } from '@nkr/models/voucher-simulation/voucher-simulation-config-output';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';

interface IProps {
    list: IVoucherSimulationConfigOutput[]
}

const Configuration: React.FunctionComponent<IProps> = (props) => {
    const columns: ColDef[] = [
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Year</SortableHeaderComponent>,
            headerName: 'Year',
            field: 'year',
            width: 50,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Assumed Growth</SortableHeaderComponent>,
            headerName: 'Assumed Growth',
            field: 'assumedGrowth',
            // width: 150,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Mortality Risk</SortableHeaderComponent>,
            headerName: 'Mortality Risk',
            field: 'mortalityRisk',
            // width: 150,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Eligibility For Transplant</SortableHeaderComponent>,
            headerName: 'Eligibility For Transplant',
            field: 'eligibilityForTransplant',
            // width: 100,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>ESRD Risk</SortableHeaderComponent>,
            headerName: 'ESRD Risk',
            field: 'esrdRisk',
            // width: 100,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
    ];

    return (
        <GridWrapper className="ag-theme-bootstrap" style={{height: 350}}>
            <AgGridReact
                columnDefs={columns}
                rowData={props.list}
                headerHeight={30}
                // context={this.state.context}
                rowHeight={35}
                // noRowsOverlayComponentFramework={() => <div>No RCCAPs found...</div>}
                suppressCellSelection={true}
                suppressRowClickSelection={true}
                onFirstDataRendered={(props: FirstDataRenderedEvent) => {
                    props.api.sizeColumnsToFit();
                }}
            >
            </AgGridReact>
        </GridWrapper>
    );
}

export default Configuration;